// extracted by mini-css-extract-plugin
export default {"recordTypesList":"recordTypesList---BL1mQ"};